<template>
    <div
        class="col-12 p-0 py-1"
        :class="offsetClass"
    >
        <div class="d-flex">
            <h4
                class="text-nowrap !text-[16px] font-semibold"
                style="color: #837db3"
            >
                {{ title }}
            </h4>
        </div>

        <div class="d-flex flex-wrap w-full">
            <Swiper
                class="responsible-swiper w-full"
                :modules="[Autoplay]"
                :slides-per-view="3.7"
                :space-between="10"
                loop
                :autoplay="{ delay: autoplayDelay }"
                :pagination="{ clickable: true }"
            >
                <SwiperSlide
                    v-for="game in games"
                    :key="game.id"
                    class="!w-auto"
                >
                    <div class="flex flex-col gap-3 justify-center">
                        <div
                            class="w-full h-[11rem]"
                            @click="handleGameClick(game)"
                        >
                            <div class="w-full h-full relative">
                                <img
                                    :src="game.image_url"
                                    :alt="game.gameName"
                                    class="w-full h-full rounded-[0.5rem]"
                                />
                            </div>
                        </div>
                        <p class="text-[20px] text-white font-semibold text-center">
                            {{ game.name }}
                        </p>
                    </div>
                </SwiperSlide>
            </Swiper>
        </div>

    </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay } from 'swiper/modules';

export default {
    name: "HotGameSection",
    components: { Swiper, SwiperSlide },
    props: {
        title: { type: String, required: true },
        games: { type: Array, required: true },
        autoplayDelay: { type: Number, default: 3000 },
        offsetClass: { type: String, default: "-mt-1" },
    },
    methods: {
        handleGameClick(game) {
            if (["PGSoft", "FaChai"].includes(game.provider)) {
                this.$emit("alert", game);
            } else {
                this.$emit("init", game);
            }
        },
    },
};
</script>
